import { PushNode } from 'utils/variableHeight/buildPushTree'
import { overlapsRangeWithDifferentY } from './range'

export const alreadyPushes = (head: PushNode, toFind: PushNode): boolean => {
  if (!head.pushes) {
    return false
  }

  for (const obj of head.pushes) {
    if (obj.objectId === toFind.objectId) {
      return true
    }

    if (alreadyPushes(obj, toFind)) {
      return true
    }
  }

  return false
}

export const searchConnected = (
  search: PushNode,
  toSearch: PushNode[],
  visited: Set<string>
): void => {
  for (const index in toSearch) {
    const obj = toSearch[index]

    if (
      !overlapsRangeWithDifferentY(obj.range, search.range) ||
      alreadyPushes(search, obj)
    ) {
      continue
    }

    if (!visited.has(obj.objectId)) {
      const i = parseInt(index)
      searchConnected(obj, toSearch.slice(i + 1), visited)
      visited.add(obj.objectId)
    }

    search.pushes.push(obj)
    obj.pushedBy.push(search)
  }
}

export const sortByY = (obj1: PushNode, obj2: PushNode) =>
  obj1.range.y - obj2.range.y

export const addChildrenToPushTree = (node: PushNode): void => {
  node.children.sort(sortByY)
  const visited = new Set<string>()

  for (const index in node.children) {
    const obj = node.children[index]

    if (!visited.has(obj.objectId)) {
      const i = parseInt(index)
      searchConnected(obj, node.children.slice(i + 1), visited)
    }
  }
}

export const calculatePushRelations = (node: PushNode): void => {
  if (!node?.children?.length) {
    return
  }

  addChildrenToPushTree(node)
}
export default calculatePushRelations
